import { useSelector } from 'react-redux';
import close from '../../../images/newDesign/close.svg';
import heart from '../../../images/newDesign/heart.svg';
import errorFrame from '../../../images/newDesign/errorFrame.svg';
import { MonthSelectionInfoPopUpStyled as PopUp } from "./MonthSelectionInfoPopUp.styled";
import Button from "../../../common/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CacheData from "../../../common/utils/cacheData";
import {SquareCheckbox} from "../../../ui/SquareCheckbox";

export default function MonthSelectionInfoPopUp({ show, setShow }) {
  const { t } = useTranslation();
  const [check, setCheck] = useState(false);
  const ltr = useSelector(state => state.common.ltrEnabled);

  const tenantDetails = CacheData.fetchCache('tenantDetails');

  const onClick = () => {
    setShow(false);
    if (check) {
      CacheData.cache('showMonthSelectionInfoPopUp', 'false');
    }
  };

  return (
    <PopUp
      className="header-with-bg"
      show={show}
      onHide={onClick}
      ltr={ltr}
    >
      <span onClick={onClick} className="modal-close">
        <img src={close} alt="close" />
      </span>
      <PopUp.Header className="text-center">
        {t('payment_settings.letsStartSettingsPayments')}
      </PopUp.Header>
      <PopUp.Body>
        <div className="modal-icon">
          <img src={errorFrame} alt="errorFrame" />
        </div>
        <p>
          {t('payment_settings.monthSelectionInfoPopUpText', {
            returnObjects: true,
            tenantName: (<strong>{tenantDetails?.name}</strong>),
            br: (<br/>),
            pay: (<strong>{t('payment_settings.monthSelectionInfoPopUpText_pay')}</strong>),
            heartImg: (<img src={heart} alt="heart" />),
          })}
        </p>
        <div dir="ltr">
          <SquareCheckbox
            checked={check}
            onChange={() => setCheck(prev => !prev)}
            label={t('payment_settings.dontShowThisMessageAgain')}
            containerClassName='selection-checkbox'
            right={!ltr}
            containerStyle={{
              justifyContent: 'flex-end'
            }}
          />
          <Button onClick={onClick} className="modal-button" rounded={false}>{t('buildings.confirm')}</Button>
        </div>
      </PopUp.Body>
    </PopUp>
  )
}
